var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property--banner-(handedover-complete)",
    transform: "translate(-107.000000, -140.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,140 C110.128854,140 107,143.128854 107,147 C107,150.871146 110.128854,154 114,154 C117.871146,154 121,150.871146 121,147 C121,143.128854 117.871146,140 114,140 Z M117.805623,145.773773 L113.367721,149.572087 C113.229436,149.69089 113.056745,149.75 112.884057,149.75 C112.71137,149.75 112.521137,149.690887 112.400394,149.572087 L110.207432,147.702454 C109.930856,147.46484 109.930856,147.09394 110.207432,146.85692 C110.484009,146.619307 110.915728,146.619307 111.191614,146.85692 L112.884092,148.310967 L116.821545,144.92821 C117.098121,144.690597 117.52984,144.690597 117.805726,144.92821 C118.064758,145.165245 118.064758,145.551203 117.805726,145.773744 L117.805623,145.773773 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferredIcon);
export default __webpack_public_path__ + "static/media/transferred_icon.5ce2aeb18ab7f87dbfa0746f98e3c933.svg";
export { ForwardRef as ReactComponent };